import { render, staticRenderFns } from "./AvaliacaoAdministracao.vue?vue&type=template&id=bcbe4578"
import script from "./AvaliacaoAdministracao.vue?vue&type=script&lang=js"
export * from "./AvaliacaoAdministracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports